import { memo, useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput/DateInput';
import Filter from '../../components/Filter/Filter';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import { theme } from '../../styles/theme';
import { useDispatch, useSelector } from 'react-redux';
import StatusContainer from '../../components/StatusContainer/StatusContainer';
import convertObjToArrayBoletos from '../TransacoesBoletos/ConvertObjToArrayBoletos';
import { bankSlipsFetchAction } from '../../store/fetchActions/bankSlipsActions';
import { bankSlipDetailFetchAction } from '../../store/fetchActions/bankSlipDetailActions';
import formatCPF from '../../utils/functions/formatCPF';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import { LoadingContainer } from '../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import { translateMessage } from '../../utils/functions/translateMessage';
import Information from '../../components/Information/Information';
import useCallFilter from '../../utils/hooks/useCallFilter';
const { mainColor, secondaryColor, rbmBlack } = theme.colors;

function TransacoesBoletos() {
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [filter, setFilter] = useState({
    search: '',
    dataInicial: '',
    dataFinal: '',
    status: 0,
    orderBy: '',
    limit: '10',
    page: '1',
  });

  const {
    paginationBankSlips,
    loadingBankSlips,
    messageBankSlips,
    dataBankSlips,
    errorBankSlips,
  } = useSelector((state) => state.bankSlips);

  const {
    dataBankSlipDetail,
    loadingBankSlipDetail,
    messageBankSlipDetail,
    errorBankSlipDetail,
  } = useSelector((state) => state.bankSlipDetail);

  const dataBankSlipDetailArray = convertObjToArrayBoletos(dataBankSlipDetail);
  const { handleSubmit, control } = useForm({});

  useCallFilter(filterData, setFilter, bankSlipsFetchAction, 0, 0);

  const filterTable = (data) => setFilterData(data);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  useEffect(() => {
    dispatch(bankSlipsFetchAction(filter));
  }, [filter.page]);

  const header = [
    {
      id: 'data de emissÃo',
      name: 'DATA DE EMISSÃO',
      align: 'center',
    },
    { id: 'cpf/cnpj remetente', name: 'CPF/CNPJ REMETENTE', align: 'left' },
    { id: 'nome remetente', name: 'NOME REMETENTE', align: 'left' },
    {
      id: 'cpf/cnpj beneficiario',
      name: 'CPF/CNPJ BENEFICIARIO',
      align: 'left',
    },
    { id: 'beneficiario', name: 'BENEFICIARIO', align: 'left' },
    { id: 'vencimento', name: 'VENCIMENTO', align: 'center' },
    { id: 'valor', name: 'VALOR', align: 'right' },
    { id: 'status', name: 'STATUS', align: 'center' },
  ];

  const body = dataBankSlips?.map((bankSlip) => {
    return {
      data: [
        {
          info: bankSlip.DATAREGISTRO,
          align: 'center',
        },
        {
          info: formatCPF(bankSlip.CPFCNPJ),
          align: 'left',
        },
        {
          info: bankSlip.NOME,
          align: 'left',
        },
        {
          info: formatCPF(bankSlip.CPFCNPJBENEFICIARIO),
          align: 'left',
        },
        {
          info: bankSlip.NOMEBENEFICIARIO,
          align: 'left',
        },
        {
          info: bankSlip.DATAVENCIMENTO,
          align: 'center',
        },
        {
          info: `R$ ${formatMoney(bankSlip.VALORDOCUMENTO)}`,
          align: 'right',
        },
        {
          info: bankSlip.STATUSID ? (
            <StatusContainer
              code={bankSlip.STATUSID}
              description={bankSlip.STATUS}
            ></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
      ],
      onClick: () => inspectUser(bankSlip.ID),
    };
  });

  const inspectUser = (id) => {
    dispatch(bankSlipDetailFetchAction(id));
    setIsModalInfoOpen(true);
  };

  const closeModalInfo = () => setIsModalInfoOpen(false);

  const arrayStatus = [
    { ID: 1, NOME: 'Aguardando' },
    { ID: 2, NOME: 'Aprovado' },
    { ID: 3, NOME: 'Cancelado' },
    { ID: 4, NOME: 'Vencido' },
  ];

  return (
    <Wrapper title="Transação de Boletos">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'search'}
                width={'25.042vw'}
                margin={'0 0 0 1.389vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <SelectOptions
                control={control}
                options={arrayStatus}
                name={'status'}
                width={'11.528vw'}
                label={'Status'}
                initialValue={0}
                initialName={'Todos'}
              />
              <DateInput
                label="Data de Início"
                name={'DATAINICIAL'}
                margin={'0'}
                width={'3.333vw'}
                control={control}
              />
              <DateInput
                label="Data Final"
                name={'DATAFINAL'}
                width={'3.333vw'}
                control={control}
              />
              <Button
                backgroundColor={secondaryColor}
                width="12.153vw"
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                margin={'0 1.389vw 0 0'}
                roleName="button-buscar-boletos"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por Página</h5>
              <SelectOptions
                control={control}
                options={pagesOptions}
                name={'limit'}
                margin={'0 0 0 1.875vw'}
                initialValue={10}
                initialName={10}
              />
              <h5>Total de Registros: {paginationBankSlips?.totalResult}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingBankSlips ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingBankSlips}
            error={errorBankSlips}
            hasPagination={true}
            filter={filter}
            pagination={paginationBankSlips}
            setFilter={setFilter}
            errorMessage={messageBankSlips}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.limit}
          />
        )}
        <Modal
          open={isModalInfoOpen}
          close={closeModalInfo}
          title="Detalhes Boleto"
          width={'45.889vw'}
        >
          {loadingBankSlipDetail ? (
            <LoadingContainer marginTop={'1vw'}>
              <CircularProgress size={'5vw'} color="inherit" />
            </LoadingContainer>
          ) : errorBankSlipDetail ? (
            <h1>{translateMessage(messageBankSlipDetail)}</h1>
          ) : (
            <Information data={dataBankSlipDetailArray} />
          )}
        </Modal>
      </div>
    </Wrapper>
  );
}

export default memo(TransacoesBoletos);
